import React from 'react';

import Invoices from './components/Invoices';
import PaymentMethod from './components/PaymentMethod';

import BillingAddress from './components/BillingAddress/BillingAddress';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import SettingsContainer from '@dashboard/components/SettingsContainer';
import SettingsHeader from '@dashboard/components/SettingsHeader';
import SettingsDivider from '@dashboard/components/SettingsDivider';

const Billing = () => {
  const { seller } = useAuth();

  return (
    <SettingsContainer>
      {seller?.stripeCustomerId && (
        <>
          <SettingsHeader id="payment-method">Payment method</SettingsHeader>

          <PaymentMethod />

          <SettingsDivider />
        </>
      )}

      <SettingsHeader id="business-address">Business address</SettingsHeader>
      <BillingAddress />

      <SettingsDivider />

      <SettingsHeader id="invoices">Invoices</SettingsHeader>
      <Invoices />
    </SettingsContainer>
  );
};

export default Billing;
